import { toast } from 'react-hot-toast'
import { PRODUCT_SELECTION_TYPE, DINING_METHOD, customToast } from '@common'

export const calculateSelectionPrice = (selectedVariant, selectedSelections) => {
    if (!selectedVariant?.selections) return 0

    return selectedVariant.selections.reduce((total, selection) => {
        const selected = selectedSelections[selection.id]
        if (!selected) return total

        if (
            selection.type === PRODUCT_SELECTION_TYPE.MULTIPLE ||
            selection.type === PRODUCT_SELECTION_TYPE.MINIMUM ||
            selection.type === PRODUCT_SELECTION_TYPE.TAKEAWAY
        ) {
            return (
                total +
                (selected.length > 0 ?
                    selected.reduce((sum, option) => sum + (option?.sellPrice * (option?.quantity || 1) || 0), 0)
                :   0)
            )
        }

        if (selection.type === PRODUCT_SELECTION_TYPE.NORMAL) {
            return (
                total +
                (selected.length > 0 ?
                    selected.reduce((sum, option) => sum + (option?.sellPrice * (option?.quantity || 1) || 0), 0)
                :   selected?.sellPrice * (selected?.quantity || 1) || 0)
            )
        }

        // For SINGLE type only
        return total + (selected?.sellPrice * (selected?.quantity || 1) || 0)
    }, 0)
}

export const validateSelections = (selectedVariant, selectedSelections, diningMethod) => {
    if (!selectedVariant.selections) return true

    const invalidSelections = selectedVariant.selections
        // if dining method is dine in, filter out take away options
        .filter(selection => {
            if (diningMethod?.value === DINING_METHOD.DineIn) {
                return selection.type !== PRODUCT_SELECTION_TYPE.TAKEAWAY
            }
            return true
        })
        .filter(selection => selection.isRequired)
        .filter(selection => {
            const selected = selectedSelections[selection.id]
            if (!selected) return true

            switch (selection.type) {
                case PRODUCT_SELECTION_TYPE.SINGLE:
                    return selected.length > 1
                case PRODUCT_SELECTION_TYPE.MULTIPLE:
                    return selected.length < 1
                case PRODUCT_SELECTION_TYPE.MINIMUM:
                    return selected.length < 2
                case PRODUCT_SELECTION_TYPE.TAKEAWAY:
                    return selected.length < 1
                case PRODUCT_SELECTION_TYPE.NORMAL:
                    return selected.length < selection.quantity
                default:
                    return false
            }
        })

    if (invalidSelections.length > 0) {
        const missingSelections = invalidSelections.map(s => s.name || 'Required option').join(', ')
        customToast.error(`Please select required options:\n${missingSelections}`)
        return false
    }

    return true
}
